module.exports = __webpack_public_path__ + "src/assets/img/foodplex.5edad37e.jpg";